import React, { useEffect, useRef, useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import ConfirmationModel from "../../Components/Common/Model/Model";
import { Divider, Grid, Pagination, Typography,Radio,Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { DcoiActions, GetPolicyByHFMCodeAndLanguageId,SubmitV_Form, UserFormData, V_GetDefaulFormLabelByUserName, V_GetPolicyByHFMCodeAndLanguageId, V_GetSubmissionsByUsername, V_GetUserDetailByUPN, V_Getsumission } from "../../Reducers/dcoi";
import { postGetFormLabelByUserName} from "../../Reducers/dcoi";
import Spinner from "../../Components/Common/Spinner/Spinner"
import './dashboardVcoi.css'
import { Box } from "@mui/material";
import InfoICon from "../../images/icons/info.svg"
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import Modal from "../../Components/Modal/Modal";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckBoxControl from "../../Components/Common/CheckBox/CheckBox";
import { styled } from "@mui/material/styles";
import Toster from "../../Components/Common/Toster/Toster";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoIconToolTip from '@mui/icons-material/Info';

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 30,
  height: 30,
  borderRadius: "50%",
  backgroundColor:
  ownerState.active || ownerState.completed ? "#212129" : "#666666",
  color: "#fff",
  fontWeight: "bold",
  fontSize: "18px",
}));


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const Dashboard = () => {
  const dispatch = useDispatch();
  const { V_PolicyDataNew, V_userformDataList, languageDropdown, V_languageData, inProgress, V_userDetails } = useSelector(
    (state) => state.dcoi
  );
  const [isConfirmed,setIsConfirmed]=useState(false);
  const [formContainer, setFormContainer] = useState(null);
  const [isModalOpenSubmit, setIsModalOpenSubmit] = React.useState(false);
  const [policyData,setPolicyData]=useState({NameOfVendor:null});
  const [rows1, setRows1] = useState([{ id: 1, Company: V_userDetails?.Company ?? "", Vendor:"", Conflict: "" }]);
  const [steps, setSteps] = useState([]);
  const [dateOfJoining ,setDateOfJoining] = useState();
  const [son,setSon]=useState();
  const [address,setAddress]=useState();
  const [message, setMessage] = useState();
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isStapperOpen, setIsStapperOpen] = useState(false);
  const [languageID,setLanguageID]=useState();
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepValues, setStepValues] = React.useState({
    0: { checkbox: false, employeeName: V_userDetails?.Name, jobTitle: V_userDetails?.JobTitle },
    1: { checkbox: false },
    2: { radio: "option1", ROWSDATA1: [] },
    3: { checkbox: false },
  });

//   const callCopilotStudio = async () => {
//     window.localStorage.getItem("accessToken")
//   const response = await fetch(
//     "https://defaultd52c9ea17c2147b182a333a74b1f74.b8.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/copilots_header_cfb15/conversations?api-version=2022-03-01-preview",
//     {
//       method: "POST",
//       headers: {
//         "Authorization": `Bearer ${window.localStorage.getItem("accessToken")}`,
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({
//         // your conversation payload
//       })
//     }
//   );

//   const data = await response.json();
//   console.log(data);
// };



  const renderHTMLWithFormData = (template, data) => {
    if (!template) return "";
    let rendered = template;
    Object.keys(data).forEach((key) => {
      const regex = new RegExp(`{${key}}`, "g");
      rendered = rendered.replace(regex, data[key] || "");
    });
    return rendered;
  };

const escapeHTML = (str = "") =>
  String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const buildConflictRowHTML = (rows = []) => {
  if (rows.length) {
    return rows
      .map((row, index) => {
        return `
          <tr>
            <td style="border:1px solid #000; padding:8px;">${index + 1}</td>

            <td style="border:1px solid #000; padding:8px;">
              <input 
                type="text" 
                disabled
                style="padding:6px; border:1px solid #ccc; background:#f5f5f5; color:#555;" 
                value="${escapeHTML(row.CompanyOrMarket)}" 
              />
            </td>

            <td style="border:1px solid #000; padding:8px;">
              <input 
                type="text" 
                disabled
                style="padding:6px; border:1px solid #ccc; background:#f5f5f5; color:#555;" 
                value="${escapeHTML(row.Vendor_Subcontractor)}" 
              />
            </td>

            <td style="border:1px solid #000; padding:8px;">
              <input 
                type="text" 
                disabled
                style="padding:6px; border:1px solid #ccc; background:#f5f5f5; color:#555;" 
                value="${escapeHTML(row.DetailConflictOfInterest)}" 
              />
            </td>
          </tr>
        `;
      })
      .join("");
  } else {
    return `
      <tr>
        <td colspan="4" 
            style="border:1px solid #000; padding:20px; font-weight:bold; text-align:center;">
          No Conflict Found
        </td>
      </tr>
    `;
  }
};




  useEffect(() => {
  const initializedFormData = {
      Name:V_userDetails?.Name || "",
      JobTitle:V_userDetails?.JobTitle || ""
  };
  const html = renderHTMLWithFormData(
    V_PolicyDataNew?.Content,
    initializedFormData
  );
    setSteps([
      {
        label: V_languageData.Key2,
        description: V_languageData.Key40,
        name: V_languageData.Key3,
        jobTitle: V_languageData.Key4,
        aggrement: V_languageData.Key7,
        isChecked: false,
        isRequired: true,
      },
      {
        label: V_languageData.Key9,
        description: html || "",
        aggrement: V_languageData.Key10,
        isChecked: false,
        isRequired: true,
        isToolTip:true,
      },
      {
        label: V_languageData.Key30,
        radioText1: V_languageData.Key32,
        radioText2: V_languageData.Key33,
        description: V_languageData.Key34,
        header3: V_languageData.Key35,
        header4: V_languageData.Key36,
        header5: V_languageData.Key37,
      },
      {
        label: V_languageData.Key20,
        description:V_PolicyDataNew.Declaration,
        aggrement: V_languageData.Key21,
        isChecked: false,
        isRequired: true,
      },
    ]);
  }, [V_languageData, V_userformDataList, V_PolicyDataNew]);

  useEffect(() => {
    dispatch(DcoiActions.activeDisplay({ menu: V_languageData?.Key_MasterPage_7, subMenu: V_languageData?.Key_MasterPage_7 }))
  }, [isStapperOpen])


  useEffect(()=>{
      dispatch(DcoiActions.activeDisplay({
      menu: "My Submission",
      subMenu: V_languageData?.Key_MasterPage_6
    }))
  },[isConfirmed])


// useEffect(() => {
//   setStepValues(prev => ({
//     ...prev,
//     2: {
//       ...prev[2],
//       ROWSDATA1: rows1    // ← always mirror rows1
//     }
//   }));
// }, [rows1]);

  useEffect(() => {
  if (!formContainer) return;
  const vendorInput = formContainer.querySelector('input[name="vendor"]');
  const vendorElement = formContainer.querySelector('#NameOfVendor');
  const vendorElement1= formContainer.querySelector('#NameOfVendor1');
  const AddressElement = formContainer.querySelector('#Address');
  const DateOfSubmissionElement = formContainer.querySelector('#DateOfSubmission');
  const FatherNameElement = formContainer.querySelector('#FatherName')
  const tableBody = formContainer.querySelector('#conflictTableBody'); // Add an id to tbody
  const nameElement = formContainer.querySelector('#Name');
  const nameElement2 = formContainer.querySelector('#Name2');
  const nameElement3 = formContainer.querySelector('#Name3');
  const jobElement = formContainer.querySelector('#JobTitle')
  if (vendorInput) vendorInput.value = policyData.NameOfVendor;
  if(AddressElement) AddressElement.textContent = address;
  if(FatherNameElement)FatherNameElement.textContent = son;
  if(DateOfSubmissionElement)DateOfSubmissionElement.textContent = new Date().toISOString().slice(0,10).split('-').reverse().join('-');
  if(nameElement)nameElement.textContent=V_userDetails?.Name;
  if(nameElement2)nameElement2.textContent=V_userDetails?.Name;
  if(nameElement3)nameElement3.textContent=V_userDetails?.Name;
  if(jobElement)jobElement.textContent=V_userDetails?.JobTitle;
  if(vendorElement)vendorElement.textContent= policyData.NameOfVendor
  if(vendorElement1)vendorElement1.textContent=policyData.NameOfVendor
    const RowData = [];
    Object.values(stepValues).forEach(item => {
    if (item.radio === "option2" && item.ROWSDATA1?.length) {
      item.ROWSDATA1.forEach(row => {
        if (row.Company && row.Vendor && row.Conflict) {
          RowData.push({
            "CompanyOrMarket": row.Company,
            'Vendor_Subcontractor': row.Vendor,
            "DetailConflictOfInterest": row.Conflict
          });
        }
      });
    }
  });
  if (tableBody)tableBody.innerHTML = buildConflictRowHTML(RowData);;
  if (vendorInput)
    vendorInput.oninput = (e) =>{
        setPolicyData(prev => ({ ...prev, NameOfVendor: e.target.value }));
        setRows1(prevRows => {
          const updatedRows = prevRows.map(row => ({
            ...row,
            Vendor: e.target.value
          }));
        setStepValues(prev => ({
          ...prev,
          2: {
            ...prev[2],
            ROWSDATA1: updatedRows
          }
        }));
        return updatedRows;
      });
        }
      }, [formContainer,policyData.NameOfVendor]);


  useEffect(() => {
    if (V_userDetails?.Company) {
      setRows1(prevRows =>
        prevRows.map(row => ({ ...row, Company: V_userDetails.Company }))
      );
    }
  }, [V_userDetails?.Company]);

  const handleAddRow1 = () => {
    const newRow = { id: rows1.length + 1, Company:V_userDetails?.Company, Vendor:policyData.NameOfVendor, Conflict: "" };
    const updatedRows1 = [...rows1, newRow];
    setRows1(updatedRows1);
    setStepValues((prevValues) => ({
      ...prevValues,
      2: { ...prevValues[2], ROWSDATA1: updatedRows1 },
    }));
  };

  const handleDeleteRow1 = (id) => {
    const updatedRows1 = rows1.filter((row) => row.id !== id);
    setRows1(updatedRows1);

    setStepValues((prevValues) => ({
      ...prevValues,
      2: { ...prevValues[2], ROWSDATA1: updatedRows1 },
    }));
  };


  useEffect(() => {
  if (!formContainer) return;
  const vendorInput = formContainer.querySelector('input[name="vendor"]');
  const AddressElement = formContainer.querySelector('#Address');
  const DateOfJoiningElement = formContainer.querySelector('#DateOfJoining');
  const DateOfJoiningPolicyElement = formContainer.querySelector('#DateOfJoiningPolicy');
  const FatherNameElement = formContainer.querySelector('#FatherName')
  const tableBody = formContainer.querySelector('#conflictTableBody'); // Add an id to tbody
  const nameElement = formContainer.querySelector('#Name');
  const nameElement2 = formContainer.querySelector('#Name2');
  const nameElement3 = formContainer.querySelector('#Name3');
  const jobElement = formContainer.querySelector('#JobTitle')
  if (vendorInput) vendorInput.value = policyData.NameOfVendor;
  if(AddressElement) AddressElement.textContent = address;
  if(FatherNameElement)FatherNameElement.textContent = son;
  if(DateOfJoiningElement)DateOfJoiningElement.textContent = dateOfJoining;
  if(DateOfJoiningPolicyElement)DateOfJoiningPolicyElement.textContent = dateOfJoining;
  if(nameElement)nameElement.textContent=V_userDetails?.Name;
  if(nameElement2)nameElement2.textContent=V_userDetails?.Name;
  if(nameElement3)nameElement3.textContent=V_userDetails?.Name;
  if(jobElement)jobElement.textContent=V_userDetails?.JobTitle;
    const RowData = [];
    Object.values(stepValues).forEach(item => {
    if (item.radio === "option2" && item.ROWSDATA1?.length) {
      item.ROWSDATA1.forEach(row => {
        if (row.Company && row.Vendor && row.Conflict) {
          RowData.push({
            "CompanyOrMarket": row.Company,
            'Vendor_Subcontractor': row.Vendor,
            "DetailConflictOfInterest": row.Conflict
          });
        }
      });
    }
  });
  if (tableBody)tableBody.innerHTML = buildConflictRowHTML(RowData);;
  if (vendorInput)
    vendorInput.oninput = (e) =>{
        setPolicyData(prev => ({ ...prev, NameOfVendor: e.target.value }));
        setRows1(prevRows =>
        prevRows.map(row => ({
          ...row,
          Vendor: e.target.value || row.Vendor // keep previous if empty
        }))
  );
  }
}, [formContainer,setPolicyData]);




  const handleCheckboxChange = (index) => {
    setStepValues((prevValues) => {
      const updatedStepValues = { ...prevValues };
      updatedStepValues[index].checkbox = !updatedStepValues[index].checkbox;
      return updatedStepValues;
    });

    setSteps((prevSteps) =>
      prevSteps.map((step, i) =>
        i === index ? { ...step, isChecked: !step.isChecked } : step
      )
    );
  };
  


  const handleRadioChange = (index, value) => {
    setStepValues((prevValues) => ({
      ...prevValues,
      [index]:{ ...prevValues[index], radio: value},
    }));
  };

  const handleNext = async () => {
    const currentStepData = stepValues[activeStep];
    try {
      let ROWSDATA1 = currentStepData.ROWSDATA1 || []; // Preserve existing data if any
      if (activeStep === 3 && currentStepData.radio === "option2") {
        ROWSDATA1 = rows1.map((row) => ({
          Company: row.Company,
          Vendor: row.Vendor,
          Conflict: row.Conflict
        }));
      }
      setStepValues((prevValues) => ({
        ...prevValues,
        [activeStep]: {
          ...prevValues[activeStep], // Preserve existing values
          ROWSDATA1, // Update ROWSDATA1 if applicable
        },
      }));

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } catch (error) {
      console.error("Error saving step data:", error);
    }
  };
  const handleSubmit = async (stepValue) => {
    const result = {
      fileName:V_userDetails.Company,
      EmployeeAddress:address,
      ParentName:son,
      VCOI_DateOfJoining:dateOfJoining.split("-").reverse().join("-"),
      VCOI_NameOfVendor:policyData.NameOfVendor,
      VCOI_UserEmail: V_userDetails.UserName,
      VCOI_Content_PolicyId: V_PolicyDataNew?.PolicyID,
      VCOI_HaveConflict: 0,
      VCOI_HaveConflictList: []
    };
    Object.values(stepValue).forEach(item => {
      if (item.radio === "option2" && item.ROWSDATA1?.length) {
        item.ROWSDATA1.forEach(row => {
          if (row.Company && row.Vendor && row.Conflict) {
            result.VCOI_HaveConflict = 1;
            result.VCOI_HaveConflictList.push({
              "CompanyOrMarket": row.Company,
              'Vendor_Subcontractor': row.Vendor,
              "DetailConflictOfInterest": row.Conflict
            });
          }
        });
      }
    });
    dispatch(SubmitV_Form({ result })).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setStepValues({
          0: { checkbox: false, employeeName: V_userDetails?.Name, jobTitle: V_userDetails?.JobTitle },
          1: { checkbox: false },
          2: { radio: "option1", ROWSDATA1: [] },
          3: { checkbox: false },
        })
        setPolicyData({NameOfVendor:null});
        setDateOfJoining("");
        setAddress("");
        setSon("");
        setActiveStep(0);
        setIsModalOpenSubmit(true); // Update state to show the modal
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success");
        setRows1([{ id: 1, Company:V_userDetails?.Company, Vendor: "", Conflict: "" }])
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.error)
        setSeverity("error");
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    });
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

const isStepValid = () => {
  const currentStep = steps[activeStep];
  const currentValues = stepValues[activeStep];
  if (!currentStep || !currentValues) return false;
  if (currentStep.isRequired && !currentValues.checkbox) return false;
  if (currentValues.radio === "option1") return true;
  const rowsToCheck = rows1;
  if (!rowsToCheck || rowsToCheck.length === 0) return false;

if (activeStep === 0) {
  const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/; // DD-MM-YYYYssss
  const isDateOfJoiningValid = dateRegex.test(dateOfJoining);
  if (!isDateOfJoiningValid || !son || !address) {
    return false; // Disable "Next" if invalid
  }
}

if (activeStep === 1) {
  const {NameOfVendor  } = policyData;
  if (!NameOfVendor?.trim()) return false;
  return true;
}

  if (activeStep === 2) {
    const hasEmptyFields = rowsToCheck.some(row =>
      !row.Conflict?.trim()
    );
    if (hasEmptyFields) return false;
  }
  
  return true;
};

  const handleRow1InputChange = (id, field, value) => {
    const updatedRows1 = rows1.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows1(updatedRows1);
    setStepValues((prevValues) => ({
      ...prevValues,
      2: { ...prevValues[2], ROWSDATA1: updatedRows1 },
    }));
  };

  const closeModel = () => {
    setIsModalOpenSubmit(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      dispatch(V_GetDefaulFormLabelByUserName()).then(async (res) => {
        if (res.payload?.data[0]?.ID) {
          setLanguageID(res.payload?.data[0]?.ID)
          await Promise.all([
            dispatch(V_GetPolicyByHFMCodeAndLanguageId({ "languageID": res.payload?.data[0]?.ID })),
            dispatch(postGetFormLabelByUserName()),
            dispatch(V_GetSubmissionsByUsername()),
            dispatch(V_GetUserDetailByUPN()),
          ]);
        }
      })

    }
    fetchData();
  }, []);

  useEffect(() => {
    dispatch(DcoiActions.activeDisplay({ menu: V_languageData?.Key_MasterPage_5, subMenu: V_languageData?.Key_MasterPage_5 }))
  }, [V_languageData])

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = V_userformDataList.slice(indexOfFirstItem, indexOfLastItem);


  const handleButtonClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleModelAction = () => {
    setModalOpen(false);
    setIsStapperOpen(true);
  };

  const ChangeLanguage = (e) => {
    const selectedLanguage = e.target.value;
    dispatch(DcoiActions.setFormLabelsData({list:languageDropdown,id:selectedLanguage}));
    setLanguageID(selectedLanguage);
    dispatch(GetPolicyByHFMCodeAndLanguageId({ "languageID": selectedLanguage }));
  };

  const handlePdfDownload = async (value) => {
    try {
      const res = await dispatch(V_Getsumission({ PdfBlobUrl: value }));
  
      if (res.payload && res.payload.data) {
        const base64Data = res.payload.data.fileContent;
        if (!base64Data) {
          console.error("Invalid Base64 data.");
          return;
        }
  
        // Convert Base64 to binary
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(fileBlob);

        const newTab = window.open(fileURL, "_blank");
        if (!newTab) {
          alert("Please allow pop-ups to view the PDF.");
        }

        setTimeout(() => {
          URL.revokeObjectURL(fileURL);
        }, 60000); // Cleanup after 1 minute
        
      } else {
        console.error("Failed to retrieve the PDF file.");
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const submitChange = () => {
    setIsConfirmed(true);
    dispatch(V_GetUserDetailByUPN());
    dispatch(V_GetSubmissionsByUsername());
    setIsStapperOpen(false);
  }



  



  return (
    <>
      <Modal
        isOpen={isModalOpenSubmit}
        onClose={closeModel}
        children={V_languageData}
        submitChange={submitChange}
      />
      <Toster
        message={message}
        severity={severity}
        alert={alert}
        setAlert={setAlert}
      />
      {/* <Box sx={{ margin: "0px 40px 10px", display: "flex", justifyContent: { xs: "left", sm: "right" }, position: "relative", right: "0px", top: { xs: "0px", sm: "-40px" } }}>
        <select
          value={languageID}
          onChange={ChangeLanguage}
          className="customSelectDashboard"
        >
          {languageDropdown.map((lang) => (
            <option key={lang.ID} value={lang.ID}>
              {lang.Language}
            </option>
          ))}
        </select>
      </Box> */}

      {isStapperOpen ? (
        ""
      ) : (
        <>
          <Grid
            container
            spacing={2}
            sx={{
              backgroundColor: "#E7E7E7",
              margin: "0px 40px",
              width: "auto",
              padding: "10px 20px",
              display: "flex",
              justifyContent: "space-between",
            }}
            alignItems="center" // Ensures vertical alignment of text and button
          >
            {/* Text Section */}
            <Grid
              sx={{
                fontSize: "12px",
                display: "flex",
                padding: "10px",
                alignItems: "center",
              }}
            >
              <img src={InfoICon} alt="info" />
              &nbsp;&nbsp;
              <Typography sx={{ paddingLeft: "10px" }}>
                {V_languageData?.Key_MySubmission_1}
              </Typography>
            </Grid>
            {/* Button Section */}
            <Grid
              sx={{
                display: `${"flex"}`,
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button className="submit-btn" onClick={handleButtonClick}>
                  {V_languageData?.Key_MySubmission_3}
              </button>
            </Grid>
          </Grid>
        </>
      )}

      {!isStapperOpen && (
        <>
          <Grid
            container
            spacing={2}
            sx={{
              padding: "20px 40px",
            }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              {/* {V_languageData.Key_MySubmission_4} */}
              Your Vendor Conflict of Interest Disclosure Statements
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                fontWeight: 600,
                color: "#5A80B7",
                textAlign: { xs: "left", sm: "right" },
                fontSize: "15px",
              }}
            >
            Last Submission Date:{" "}
            {V_userDetails?.LastSubmission
              ? new Date(V_userDetails.LastSubmission).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              : "No Submissions"}

            </Grid>
          </Grid>
          <Box sx={{ margin: "10px 40px", overflowX: "auto" }}>
            <Box sx={{ minWidth: "700px" }}>
              <Box>
                <Grid
                  container
                  alignItems="center"
                  spacing={2}
                  sx={{
                    padding: "12px 10px",
                    backgroundColor: "#f1f1f1",
                    borderBottom: "2px solid lightgray",
                    textAlign: "left",
                    color: "#4D4D4D",
                    marginBottom: "10px",
                  }}
                >
                  <Grid item xs={1} sm={1} md={1}>
                    <Typography sx={{ fontWeight: 600 }}>
                      {V_languageData.Key_MySubmission_9}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <Typography sx={{ fontWeight: 600 }}>
                      {" "}
                      {V_languageData.Key_MySubmission_10}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography sx={{ fontWeight: 600 }}>
                      {" "}
                      {V_languageData.Key_MySubmission_11}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <Typography sx={{ fontWeight: 600 }}>
                      {V_languageData.Key_MySubmission_12}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <Typography sx={{ fontWeight: 600 }}>
                      {V_languageData.Key_MySubmission_13}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}></Grid>
                </Grid>
              </Box>
              {Array.isArray(currentItems) && currentItems.length > 0 ? (
                currentItems?.map((item, index) => (
                  <Box key={index}>
                    <Grid
                      container
                      alignItems="center"
                      spacing={2}
                      sx={{
                        fontWeight: "bold",
                        padding: "12px 10px",
                        textAlign: "left",
                        flexWrap: "nowrap", // Prevents wrapping
                      }}
                    >
                      <Grid item xs={1} sm={1} md={1}>
                        <Typography>{item.year}</Typography>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>{item.Location}</Typography>
                      </Grid>
                      <Grid item xs={3} sm={3} md={3}>
                        <Typography>{item.JobTitle}</Typography>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>{item.HFMCode}</Typography>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography>
                          {new Date(item.signoff).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        sx={{
                          display: { xs: "none", sm: "none", md: "flex" },
                          alignItems: "center",
                          color: "#9D833E",
                          cursor: "pointer",
                        }}
                        onClick={() => handlePdfDownload(item.PdfBlobUrl)}
                      >
                        <Typography
                          sx={{
                            backgroundColor: "#e6e6e6",
                            fontWeight: 500,
                            padding: "4px 10px",
                            borderRadius: "10px",
                            color: "#212129",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          {V_languageData.Key26}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        sx={{
                          display: { xs: "flex", sm: "flex", md: "none" },
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => handlePdfDownload(item.PdfBlobUrl)}
                      >
                        <VisibilityIcon />
                      </Grid>
                    </Grid>
                    <Divider />
                  </Box>
                ))
              ) : (
                <>
                  {!inProgress &&
                    V_userformDataList?.length > 0 &&
                    currentItems?.length === 0 && (
                      <Typography
                        sx={{
                          margin: "20px",
                          textAlign: "center",
                          color: "gray",
                          fontStyle: "italic",
                        }}
                      >
                        {V_languageData?.Key_MySubmission_16}
                      </Typography>
                    )}
                  <Divider
                    sx={{
                      margin: "0px 20px",
                      padding: "0.5px 0px",
                      background: "lightgray",
                    }}
                  />
                </>
              )}

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                {V_userformDataList?.length > 0 ? (
                  <Pagination
                    showFirstButton
                    showLastButton
                    sx={{
                      margin: "10px",
                      padding: "5px",
                      border: "1px solid #212129",
                      borderRadius: "20px",
                    }}
                    count={Math.ceil(V_userformDataList.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                  />
                ) : (
                  ""
                )}
              </Box>
            </Box>
          </Box>
        </>
      )}
      <ConfirmationModel
        open={isModalOpen}
        handleOpen={handleCloseModal}
        data={V_PolicyDataNew}
        handleModelAction={handleModelAction}
        languageData={V_languageData}
      />

      {isStapperOpen && (
        <Box sx={{ margin: "0px 40px" }}>
          <Typography sx={{ fontSize: "14px", padding: "20px 0px" }}>
            {V_languageData.Key1}
          </Typography>
          <Divider />
          <Box p={2}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        {...props}
                        ownerState={{
                          active: props.active,
                          completed: props.completed,
                        }}
                      >
                        {index + 1} {/* Displaying the step number */}
                      </CustomStepIcon>
                    )}
                  >
                    <span className="customSpan">{step.label}</span>
                  </StepLabel>
                  <StepContent>
                    <div
                      id="formContainer"
                        ref={(el) => {
                          setFormContainer(el);  // this ALWAYS gets the real DOM
                        }}
                      style={{ color: "#212129", fontSize: "12px" }}
                      dangerouslySetInnerHTML={{ __html: step.description }}
                    ></div>
                    {step.name && step.jobTitle && (
                      <Grid
                        container
                        spacing={2}
                        alignItems="flex-start"
                        sx={{ mt: 2 }}
                      >
                        {(!V_userDetails?.Name || !V_userDetails.JobTitle) && (
                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                padding: "10px 0px",
                                color: "#7A7A7A",
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#E7E7E7",
                                paddingX: 2,
                              }}
                            >
                              <WarningIcon />
                              &nbsp;&nbsp;{V_languageData.Key23}
                            </Typography>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography
                            variant="caption"
                            display="block"
                            fontWeight={800}
                            fontSize={14}
                          >
                            {V_languageData.Key3}{" "}
                            <span className="customSpanAlert">*</span>
                          </Typography>
                          <input
                          type="text"
                          value={V_userDetails?.Name}
                          disabled
                          onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                          onPaste={(e) => e.preventDefault()} // Prevent pasting a value
                          className="customDateInputVcoi"
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography
                            variant="caption"
                            display="block"
                            fontWeight={800}
                            fontSize={14}
                          >
                            {V_languageData.Key4}{" "}
                            <span className="customSpanAlert">*</span>
                          </Typography>
                          <input
                          type="text"
                          value={V_userDetails?.JobTitle}
                          disabled
                          onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                          onPaste={(e) => e.preventDefault()} // Prevent pasting a value
                          className="customDateInputVcoi"
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography
                            variant="caption"
                            display="block"
                            fontWeight={800}
                            fontSize={14}
                          >
                            Resident of
                            {/* {V_languageData.Key3}{" "} */}
                            <span className="customSpanAlert">*</span>
                          </Typography>
                          <input
                          type="text"
                          value={address}
                          placeholder="Address"
                          onChange={(e) => {
                            setAddress(e.target.value);
                          }}
                          className="customDateInputVcoi"
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography
                            variant="caption"
                            display="block"
                            fontWeight={800}
                            fontSize={14}
                          >
                            Son/Daughter Of 
                            {/* {V_languageData.Key3}{" "} */}
                            <span className="customSpanAlert">*</span>
                          </Typography>
                          <input
                          type="text"
                          placeholder="Son/Daughter Of"
                          value={son}
                          onChange={(e) => {
                            setSon(e.target.value);
                          }}
                          className="customDateInputVcoi"
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography
                            variant="caption"
                            display="block"
                            fontWeight={800}
                            fontSize={14}
                          >
                            Date Of Joining
                            {/* {V_languageData.Key3}{" "} */}
                            <span className="customSpanAlert">*</span>
                          </Typography>
                          <input
                          type="date"
                          value={dateOfJoining ? dateOfJoining.split("-").reverse().join("-") : ""}
                          max={new Date().toISOString().split("T")[0]} 
                          onChange={(e) => {
                            const value = e.target.value;
                            const formattedValue = value.split("-").reverse().join("-");
                            setDateOfJoining(formattedValue);
                          }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.currentTarget.showPicker();
                          }}
                          onFocus={(e) => e.target.showPicker()}
                          onPaste={(e) => e.preventDefault()}
                          className="customDateInputVcoi"
                        />
                        </Grid>
                      </Grid>
                    )}
                    {step.isToolTip && (<Typography sx={{display:"flex",textAlign:"center",fontWeight:"bold"}}><InfoIconToolTip/>&nbsp;<em>Name Of Vendor or Sub-Contractor field is required</em></Typography>)
                             }
                    {step.aggrement && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "16px",
                          backgroundColor: "#f2f2f2",
                          padding: "20px",
                        }}
                      >
                        <CheckBoxControl
                          value={step.isChecked}
                          onChange={() => handleCheckboxChange(index)}
                        />
                        <Typography
                          sx={{ fontSize: "12px", marginLeft: "8px",display:"flex",textAlign:"center" }}
                          onClick={() => handleCheckboxChange(index)}
                        >
                          {step.aggrement}
                          &nbsp;
                          {/* {step.isToolTip && <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit"><em>Name Of Vendor or Sub-Contractor Field Required to Enable Next Button</em></Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoIconToolTip/>
                          </HtmlTooltip> } */}
                          <span className="customSpanAlert">*</span>
                        </Typography>
                      </Box>
                    )}
                    {step.radioText1 && (
                      <Box
                        sx={{
                          backgroundColor: "#f2f2f2",
                          margin: "17px",
                          padding: "0px 4px",
                        }}
                      >
                        <Typography>
                          <label>
                            <Radio
                              checked={stepValues[index].radio === "option1"}
                              sx={{
                                color: "black",
                                '&.Mui-checked': {
                                  color: "black",
                                },
                              }}
                              onChange={() =>
                                handleRadioChange(index, "option1")
                              }
                            />
                            {step.radioText1}
                          </label>
                        </Typography>
                        <Typography>
                          <label>
                            <Radio
                              checked={stepValues[index].radio === "option2"}
                              sx={{
                                color: "black",
                                '&.Mui-checked': {
                                  color: "black",
                                },
                              }}
                              onChange={() =>
                                handleRadioChange(index, "option2")
                              }
                            />
                            {step.radioText2}
                          </label>
                        </Typography>
                      </Box>
                    )}
                    <>
                      <Grid
                        container
                        spacing={{ xs: 2, sm: 2 }}
                        px={{ xs: 2, sm: 2 }}
                        sx={{
                          margin: "4px 0",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          sx={{
                            fontWeight: "bold",
                            display: { xs: "none", md: "flex" },
                          }}
                        >
                          {step.header3}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={3}
                          sx={{
                            fontWeight: "bold",
                            display: { xs: "none", md: "flex" },
                          }}
                        >
                          {step.header4}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={3}
                          sx={{
                            fontWeight: "bold",
                            display: { xs: "none", md: "flex" },
                          }}
                        >
                          {step.header5}
                        </Grid>
                      </Grid>
                      {step.header3 &&
                        step.header4 &&
                        step.header5 &&
                        rows1.map((row, index) => (
                          <Grid
                            container
                            key={row.id}
                            spacing={{ xs: 2, sm: 2 }}
                            px={{ xs: 2, sm: 2 }}
                            sx={{
                              margin: "4px 0",
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={4}
                              sx={{
                                fontWeight: "bold",
                                display: { xs: "flex", md: "none" },
                                marginTop: "30px",
                              }}
                            >
                              {step.header3}
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}>
                              <input
                                value={row.Company}
                                disabled={true}
                                // disabled={stepValues[2].radio !== "option2"}
                                // onChange={(e) =>
                                //   handleRow1InputChange(
                                //     row.id,
                                //     "Company",
                                //     e.target.value
                                //   )
                                // }
                                className="customInputStapper"
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              sx={{
                                fontWeight: "bold",
                                display: { xs: "flex", md: "none" },
                              }}
                            >
                              {step.header4}
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                              <input
                                value={row.Vendor}
                                disabled={true}
                                // onChange={(e) =>
                                //   handleRow1InputChange(
                                //     row.id,
                                //     "Vendor",
                                //     e.target.value
                                //   )
                                // }
                                className="customInputStapper"
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              sx={{
                                fontWeight: "bold",
                                display: { xs: "flex", md: "none" },
                              }}
                            >
                              {step.header5}
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                              <input
                                type="text"
                                value={row.Conflict}
                                disabled={stepValues[2].radio !== "option2"}
                                onChange={(e) =>
                                  handleRow1InputChange(
                                    row.id,
                                    "Conflict",
                                    e.target.value
                                  )
                                }
                                className="customInputStapper"
                              />
                            </Grid>
                            {step.label ===
                              "Vendor Conflict of Interest Declaration" &&
                              index === 0 && (
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={2}
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Typography
                                    sx={{
                                      padding: "10px",
                                      color:
                                        stepValues[2].radio !== "option2"
                                          ? "grey"
                                          : "#212129",
                                      fontSize: "12px",
                                      fontWeight: "bolder",
                                      cursor:
                                        stepValues[2].radio !== "option2"
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        stepValues[2].radio !== "option2"
                                          ? 0.6
                                          : 1,
                                    }}
                                    variant="contained"
                                    onClick={() => {
                                      if (stepValues[2].radio !== "option1") {
                                        handleAddRow1();
                                      }
                                    }}
                                  >
                                    {V_languageData.Key18} +
                                  </Typography>
                                </Grid>
                              )}
                            {index > 0 && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={1}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <DeleteForeverIcon
                                  sx={{
                                      height: "34px",
                                      width:"25px",
                                      color:
                                        stepValues[2].radio !== "option2"
                                          ? "grey"
                                          : "#212129",
                                      fontSize: "12px",
                                      fontWeight: "bolder",
                                      cursor:
                                        stepValues[2].radio !== "option2"
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        stepValues[2].radio !== "option2"
                                          ? 0.6
                                          : 1,
                                    }}
                                  onClick={() => handleDeleteRow1(row.id)}
                                />
                              </Grid>
                            )}
                          </Grid>
                        ))}
                    </>
                    <Box sx={{ mt: 2, ml: 2 }}>
                      {index === 0 ? (
                        ""
                      ) : (
                        <Button
                          disabled={index === 0 ? true : false}
                          onClick={handleBack}
                          sx={{
                            mt: 1,
                            mr: 1,
                            p: 1,
                            borderRadius: "20px",
                            backgroundColor: "#e6e6e6",
                            color: "#212129",
                          }}
                        >
                          {V_languageData.Key28}
                        </Button>
                      )}

                      <Button
                        variant="contained"
                        onClick={() => {
                          if (activeStep === steps.length - 1) {
                            handleSubmit(stepValues);
                          } else {
                            handleNext();
                          }
                        }}
                        sx={{
                          mt: 1,
                          mr: 1,
                          p: 1,
                          borderRadius: "20px",
                          backgroundColor: "#212129",
                          color: "white",
                        }}
                        disabled={!isStepValid()}
                      >
                        {activeStep === steps.length - 1
                          ? V_languageData.Key22
                          : V_languageData.Key8}
                      </Button>
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Box>
      )}
      <Spinner isLoading={inProgress} />
    </>
  );
};
export default Dashboard;